$(() => {
  let currentSection = null
  const sections = document.querySelectorAll('[data-page-background]')
  const header = document.querySelector('header.main')
  const logo = header.querySelector('.logo')

  const logoDefault = logo.innerHTML
  const sectionTitleClass = 'section-title'
  let timeout = null

  // set initial color without transition
  document.documentElement.style.setProperty(
    '--page-background-color',
    sections[0]?.dataset?.pageBackground,
  )
  window.requestAnimationFrame(() => {
    header.classList.add('with-transition')
  })

  function setLogoText(text) {
    logo.classList.add('out')
    if (text !== false) {
      logo.addEventListener(
        'transitionend',
        () => {
          logo.innerHTML = text
          logo.classList.add(sectionTitleClass)
          logo.classList.remove('out')
        },
        {
          once: true,
        },
      )
    } else {
      logo.classList.add('out')
      logo.addEventListener(
        'transitionend',
        () => {
          logo.innerHTML = logoDefault
          logo.classList.remove(sectionTitleClass)
          logo.classList.remove('out')
        },
        { once: true },
      )
    }
  }

  function logoTextHandler(e) {
    let section = e.section
    let text = section?.dataset?.title || false
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      setLogoText(text)
    }, 150)
  }

  function headerColorHandler(e) {
    let section = e.section
    let hexCode = section?.dataset?.pageBackground
    if (hexCode) {
      document.documentElement.style.setProperty('--page-background-color', hexCode)
    }
  }

  function scrollHandler() {
    let newCurrentSection = null
    const headerHeight = parseInt(
      getComputedStyle(document.body).getPropertyValue('--header-height'),
    )
    const targetOffset = pageYOffset + headerHeight

    sections.forEach(section => {
      let upperOffset = section.offsetTop
      let lowerOffset = section.offsetTop + section.getBoundingClientRect().height
      if (upperOffset <= targetOffset && lowerOffset > targetOffset) {
        newCurrentSection = section
      }
      let sectionChanged = newCurrentSection && newCurrentSection !== currentSection
      if (sectionChanged || currentSection === null) {
        currentSection = newCurrentSection
        let event = new Event('sectionChanged')
        event.section = currentSection
        window.dispatchEvent(event)
      }
    })
  }

  window.addEventListener('scroll', scrollHandler, {
    passive: true,
  })

  window.addEventListener('sectionChanged', headerColorHandler)
  window.addEventListener('sectionChanged', logoTextHandler)
})
